export function isNewPasswordValid(newPassword: string, confirmNewPassword: string, isPasswordGenerated: boolean) {
	return (isPasswordGenerated || newPassword === confirmNewPassword) && checkIsStrongPassword(newPassword)
}

function checkIsStrongPassword(password: string) {
	const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{12,}$")
	return strongRegex.test(password)
}
